module.exports = "<app-dashboards [dashboardType]=\"dashboardType\" ></app-dashboards>\n"